import BaseCustomSelect from './baseComponents/BaseCustomSelect';
import countries from './data/countries';
import getCookie from './utils/getCookie';

/**
 * A custom element for enhancing a <select> tag of countries into a custom combobox with icons for each selection
 *
 * @module iabbb-country-custom-select
 */
class CountryCustomSelect extends BaseCustomSelect {
  getInitialValue = () => {
    const queryParams = new URLSearchParams(window.location.search);

    const searchedCountry = queryParams.get('find_country');

    const savedCulture = getCookie('iabbb_user_culture');

    if (searchedCountry) {
      return countries.find((x) => x.value === searchedCountry)?.value || this.select.value;
    }

    if (savedCulture) {
      return countries.find((x) => x.culture === savedCulture.toLowerCase())?.value || this.select.value;
    }

    return this.select.value;
  };

  getComboboxHtml = (val) => {
    const country = countries.find((x) => x.value === val);
    return `
      <img src="${country.flag}" alt="" />
      <span aria-hidden>${country.shortLabel}</span>
      <span class="visually-hidden">${country.fullLabel}</span>
    `;
  };

  getOptionHtml = (val) => {
    const country = countries.find((x) => x.value === val);
    return `<img src="${country.flag}" alt="" />${country.fullLabel}`;
  };

  optionClassName = 'dtm-header-near-typeahead-country-item';
}

customElements.define('iabbb-country-custom-select', CountryCustomSelect);
